import DemandService from '@/services/demand.service'
import moment from 'moment'
import Utils from '@/utils'

const state = {
    listPage: {
        results: [],
        count: 0,
        next: null,
        previous: null
    },
    filterLoading: false,
    demands: {}
}

const getters = {}

const actions = {
    readListDemands: async ({ commit }, args) => {
        if (!args) args = {}
        if (!args.page) args.page = 1
        if (state.listPage.index == args.page) return true
        try {
            commit('reading')
            const page = await DemandService.readListDemands(args)
            commit('readListDemandsSuccess', page.data, args.page)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    updateIntervalDemand: async ({ commit }, args) => {
        try {
            const { id, quantity } = args

            await DemandService.updateIntervalDemand(id, quantity)
            commit('updateIntervalDemand')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    updateDateNapDemand: async ({ commit }, args) => {
        try {
            const demand_ids = args.map(arg => arg.id).join(',')

            const datetime_nap = moment(args[0].date_nap, 'DD/MM/YYYY').format(
                'YYYY-MM-DD HH:mm:ss'
            )

            const demand_id = args[0].id

            await DemandService.updateDateNapDemand({
                demand_id,
                demand_ids,
                datetime_nap
            })
            commit('updateDateNapDemandSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    readDemands: async ({ commit }, args) => {
        try {
            commit('reading')
            const response = await DemandService.readDemands(args)
            commit('readDemandsSuccess', response.data)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    create: async ({ commit }, args) => {
        try {
            await DemandService.create(args)
            commit('createDemandSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    update: async ({ commit }, args) => {
        try {
            await DemandService.update(args)
            commit('updateDemandSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    }
}

const mutations = {
    reading(state) {
        state.filterLoading = true
    },

    readListDemandsSuccess(state, page, page_index) {
        Utils.datetimeConverter(page.results)
        state.listPage = page
        state.listPage.next = page.next
        state.listPage.previous = page.previous
        state.filterLoading = false
    },

    readDemandsSuccess(state, page) {
        const series = Utils.demandsSeriesConverter(page)
        state.demands = series
        state.filterLoading = false
    },

    updateIntervalDemand(state) {
        // success
    },

    updateDateNapDemandSuccess(state) {
        // success
    },

    createDemandSuccess(state) {
        // success
    },

    updateDemandSuccess(state) {
        // success
    }
}

const demands = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default demands
export { demands }
